export default function initTimeline() {
    // ==========================================================
    // TIMELINE
    // ==========================================================

    const timelines = document.querySelectorAll("[data-timeline]");

    timelines.forEach((timeline) => {
        const items = timeline.querySelectorAll("[data-timeline-item]");
        const progress = timeline.querySelector("[data-timeline-progress]");

        if (!items.length) {
            return;
        }

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("is-visible");
                    }
                });
            },
            {
                threshold: 0.25,
            },
        );

        items.forEach((item) => {
            observer.observe(item);
        });

        if (!progress) {
            return;
        }

        const updateTimelineProgress = () => {
            const rect = timeline.getBoundingClientRect();
            const viewportHeight = window.innerHeight;

            const start = viewportHeight * 0.65;
            const end = viewportHeight * 0.25;

            const travelled = start - rect.top;
            const total = rect.height - end;

            let ratio = travelled / total;

            ratio = Math.max(0, Math.min(1, ratio));

            progress.style.transform = `scaleY(${ratio})`;
        };

        updateTimelineProgress();

        window.addEventListener("scroll", updateTimelineProgress, {
            passive: true,
        });

        window.addEventListener("resize", updateTimelineProgress);
    });
}
